import API, { baseURL } from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'estructura-organizacional/historico-sbc-empleado';

export const getHistoricoSBCEmpleado = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Historico SBC Empleado (vista optimizada, SQL con JOINs, campos planos)
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getHistoricoSBCEmpleadoVistaOptimizada = async (params) => {
  try {
    const response = await API.get(`${baseURI}-vista-optimizada`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const postHistoricoSBCEmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

export const patchHistoricoSBCEmpleado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

export const deleteHistoricoSBCEmpleado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};

export const descargarPlantillaSBC = async () => {
  try {
    const response = await API.get(`${baseURI}/plantilla/`, {
      responseType: 'arraybuffer',
    });
    if (response?.data) {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'plantilla_sbc_empleados.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const importarSBCEmpleado = async (archivo) => {
  const formData = new FormData();
  formData.append('archivo', archivo);
  const response = await API.post(
    `${baseURL}estructura-organizacional/historico-sbc-empleado-importar-excel/`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response;
};
